const instagramImages = [
  {
    src: "https://sofiajewelry.com/cdn/shop/files/CCSept-15.jpg?v=1775503819",
    alt: "Model wearing layered gold necklaces from Sofia Jewelry",
  },
  {
    src: "https://sofiajewelry.com/cdn/shop/files/Yellow_Diamond_Bracelets_1.jpg?v=1774499726",
    alt: "Yellow diamond bracelets styled on a neutral background",
  },
  {
    src: "https://sofiajewelry.com/cdn/shop/files/DSC_2525_33e6f0e9-34bb-4d75-af30-d57047bcba43.jpg?v=1731924218",
    alt: "Jeweler crafting a bespoke custom creation at the workbench",
  },
  {
    src: "https://sofiajewelry.com/cdn/shop/files/R15625YB-1.jpg?v=1778712073",
    alt: "14 karat yellow gold diamond band close up",
  },
  {
    src: "https://sofiajewelry.com/cdn/shop/files/Sofia_Jewelry_16eebfd6-d343-43d1-8e03-e294502f9412.jpg?v=1787373103",
    alt: "Fine jewelry editorial styled by Sofia Jewelry",
  },
  {
    src: "https://sofiajewelry.com/cdn/shop/files/CASSI-P-1.jpg?v=1765476712",
    alt: "Sterling silver CASSI disc pendant with scattered diamonds",
  },
];

export default function InstagramSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <header className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-light tracking-[0.16em] text-foreground-950">
            @sofiajewelry
          </h2>
          <p className="font-body text-sm text-foreground-500 mt-3">
            Follow along for new arrivals, custom work and daily sparkle.
          </p>
        </header>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {instagramImages.map((image) => (
            <a
              key={image.src}
              href="https://www.instagram.com/sofiajewelry/"
              target="_blank"
              rel="noopener nofollow"
              className="group relative block w-full aspect-square overflow-hidden bg-background-100"
            >
              <img
                src={image.src}
                alt={image.alt}
                title="Sofia Jewelry on Instagram"
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
              />
              <span className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/25 transition-colors flex items-center justify-center">
                <i className="ri-instagram-line text-2xl text-background-50 opacity-0 group-hover:opacity-100 transition-opacity" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}